/* ============================================
   COLLAGENA HOMEPAGE ANIMATIONS SCRIPT
   Scroll Reveal & Interactive Effects
   ============================================ */

(function() {
  'use strict';
  
  // Wait for DOM
  document.addEventListener('DOMContentLoaded', function() {
    
    // ============================================
    // SCROLL REVEAL ANIMATIONS
    // ============================================
    const animateElements = document.querySelectorAll('.clg-animate, .clg-animate-left, .clg-animate-right, .clg-animate-scale, .clg-stagger-children');
    
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.1
    };
    
    const animationObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          // Optionally unobserve after animation
          // animationObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    animateElements.forEach(function(el) {
      animationObserver.observe(el);
    });
    
    // ============================================
    // PARALLAX EFFECT
    // ============================================
    const parallaxElements = document.querySelectorAll('.clg-parallax');
    
    if (parallaxElements.length > 0) {
      window.addEventListener('scroll', function() {
        const scrolled = window.pageYOffset;
        
        parallaxElements.forEach(function(el) {
          const speed = el.dataset.speed || 0.5;
          el.style.transform = 'translateY(' + (scrolled * speed) + 'px)';
        });
      }, { passive: true });
    }
    
    // ============================================
    // COUNTER ANIMATION
    // ============================================
    const counters = document.querySelectorAll('.clg-counter');
    
    counters.forEach(function(counter) {
      const counterObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const target = parseInt(counter.dataset.target);
            const duration = parseInt(counter.dataset.duration) || 2000;
            const increment = target / (duration / 16);
            let current = 0;
            
            const updateCounter = function() {
              current += increment;
              if (current < target) {
                counter.textContent = Math.floor(current);
                requestAnimationFrame(updateCounter);
              } else {
                counter.textContent = target;
              }
            };
            
            updateCounter();
            counterObserver.unobserve(counter);
          }
        });
      }, { threshold: 0.5 });
      
      counterObserver.observe(counter);
    });
    
    // ============================================
    // MAGNETIC BUTTON EFFECT
    // ============================================
    const magneticBtns = document.querySelectorAll('.clg-magnetic');
    
    magneticBtns.forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        
        btn.style.transform = 'translate(' + (x * 0.2) + 'px, ' + (y * 0.2) + 'px)';
      });
      
      btn.addEventListener('mouseleave', function() {
        btn.style.transform = 'translate(0, 0)';
      });
    });
    
    // ============================================
    // TILT EFFECT ON CARDS
    // ============================================
    const tiltCards = document.querySelectorAll('.clg-tilt');
    
    tiltCards.forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = (y - centerY) / 10;
        const rotateY = (centerX - x) / 10;
        
        card.style.transform = 'perspective(1000px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
      });
      
      card.addEventListener('mouseleave', function() {
        card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0)';
      });
    });
    
    // ============================================
    // SMOOTH SCROLL FOR ANCHOR LINKS
    // ============================================
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href !== '#' && href !== '#0') {
          const target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    });
    
    // ============================================
    // TEXT TYPING EFFECT
    // ============================================
    const typingElements = document.querySelectorAll('.clg-typing');
    
    typingElements.forEach(function(el) {
      const text = el.dataset.text || el.textContent;
      const speed = parseInt(el.dataset.speed) || 50;
      el.textContent = '';
      el.style.visibility = 'visible';
      
      let i = 0;
      function type() {
        if (i < text.length) {
          el.textContent += text.charAt(i);
          i++;
          setTimeout(type, speed);
        }
      }
      
      const typingObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            type();
            typingObserver.unobserve(el);
          }
        });
      }, { threshold: 0.5 });
      
      typingObserver.observe(el);
    });
    
    // ============================================
    // CURSOR GLOW EFFECT
    // ============================================
    const glowContainers = document.querySelectorAll('.clg-cursor-glow');
    
    glowContainers.forEach(function(container) {
      const glow = document.createElement('div');
      glow.className = 'clg-glow-element';
      glow.style.cssText = 'position: absolute; width: 200px; height: 200px; background: radial-gradient(circle, rgba(93, 44, 83, 0.15) 0%, transparent 70%); pointer-events: none; transform: translate(-50%, -50%); opacity: 0; transition: opacity 0.3s;';
      container.style.position = 'relative';
      container.style.overflow = 'hidden';
      container.appendChild(glow);
      
      container.addEventListener('mousemove', function(e) {
        const rect = container.getBoundingClientRect();
        glow.style.left = (e.clientX - rect.left) + 'px';
        glow.style.top = (e.clientY - rect.top) + 'px';
        glow.style.opacity = '1';
      });
      
      container.addEventListener('mouseleave', function() {
        glow.style.opacity = '0';
      });
    });
    
    // ============================================
    // IMAGE LAZY LOAD WITH FADE
    // ============================================
    const lazyImages = document.querySelectorAll('img[data-src]');
    
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.classList.add('clg-img-loaded');
            imageObserver.unobserve(img);
          }
        });
      });
      
      lazyImages.forEach(function(img) {
        imageObserver.observe(img);
      });
    }
    
    // ============================================
    // HEADER SCROLL EFFECT
    // ============================================
    let lastScroll = 0;
    const header = document.querySelector('.shopify-section-header');
    
    if (header) {
      window.addEventListener('scroll', function() {
        const currentScroll = window.pageYOffset;
        
        if (currentScroll > 100) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
        
        // Hide/Show header on scroll direction
        if (currentScroll > lastScroll && currentScroll > 200) {
          header.classList.add('header-hidden');
        } else {
          header.classList.remove('header-hidden');
        }
        
        lastScroll = currentScroll;
      }, { passive: true });
    }
    
    // ============================================
    // RIPPLE EFFECT ON BUTTONS
    // ============================================
    document.querySelectorAll('.clg-ripple-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        const ripple = document.createElement('span');
        const rect = btn.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;
        
        ripple.style.cssText = 'position: absolute; width: ' + size + 'px; height: ' + size + 'px; left: ' + x + 'px; top: ' + y + 'px; background: rgba(255, 255, 255, 0.5); border-radius: 50%; transform: scale(0); animation: ripple-effect 0.6s linear; pointer-events: none;';
        
        btn.style.position = 'relative';
        btn.style.overflow = 'hidden';
        btn.appendChild(ripple);
        
        setTimeout(function() {
          ripple.remove();
        }, 600);
      });
    });
    
    // Add ripple keyframes
    if (!document.getElementById('clg-ripple-style')) {
      const style = document.createElement('style');
      style.id = 'clg-ripple-style';
      style.textContent = '@keyframes ripple-effect { to { transform: scale(4); opacity: 0; } }';
      document.head.appendChild(style);
    }
    
    // ============================================
    // PROGRESS BAR ON SCROLL
    // ============================================
    const progressBar = document.querySelector('.clg-scroll-progress');
    
    if (progressBar) {
      window.addEventListener('scroll', function() {
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrolled = (winScroll / height) * 100;
        progressBar.style.width = scrolled + '%';
      }, { passive: true });
    }
    
  });
})();
